import $ from 'jquery';

import { FirebaseApp } from "firebase/app";
import { Auth, signInWithCustomToken } from "firebase/auth";

import { Session } from "./session.js";
import { API, SignUpFields } from "./api.js";

type ValidationError = {message: string}
type ValidationErrors = ValidationError[]

type ValidationResponse = {
    ok: boolean,
    errors: ValidationErrors
}

class Signup {

    protected session: Session;
    protected firebaseApp: FirebaseApp;
    protected firebaseAuth: Auth;
    protected api: API;

    protected errorMessage: HTMLElement;

    protected signUpForm: HTMLElement;
    protected nameInput: HTMLInputElement;
    protected emailInput: HTMLInputElement;
    protected passwordInput: HTMLInputElement;
    protected orgInput: HTMLInputElement;

    protected passwordShowHideButton: HTMLElement;

    protected signUpButton: HTMLInputElement;

    constructor(session: Session) {
        this.session = session;
        this.firebaseApp = session.getFirebaseApp();
        this.firebaseAuth = session.getFirebaseAuth();
        this.api = session.getAPI();

        this.errorMessage = document.getElementById('error-msg') as HTMLElement;
        this.signUpForm = document.getElementById('signup-form') as HTMLElement;

        this.nameInput = document.getElementById('name-input') as HTMLInputElement;
        this.emailInput = document.getElementById('email-input') as HTMLInputElement;
        this.passwordInput = document.getElementById('password-input') as HTMLInputElement;
        this.orgInput = document.getElementById('org-input') as HTMLInputElement;

        this.passwordShowHideButton = document.getElementById('password-show-hide-button') as HTMLElement;
        this.signUpButton = document.getElementById('sign-up-email-btn') as HTMLInputElement;

        $(this.signUpForm).on('submit', this.onSignUpSubmit.bind(this));
        $(this.signUpForm).on('click', '#password-show-hide-button', this.onPasswordShowHideButtonClick.bind(this));
    }

    protected async signUp() {
        const fields = {
            name: this.nameInput.value,
            email: this.emailInput.value,
            password: this.passwordInput.value,
            organization: this.orgInput.value
        }

        this.signUpButton.value = `Creating Account...`;

        const validationResponse = await this.validateFields(fields);

        this.errorMessage.style.display = 'none';

        if (validationResponse.ok) {
            try {
                const payload = await this.api.signUp(fields);

                if (payload.ok && payload.token !== null) {
                    try {
                        await signInWithCustomToken(this.firebaseAuth, payload.token);
                        await this.session.setCookie();
                        this.redirectAfterSignup();
                    }
                    catch (error) {
                        this.showErrors([{message: (error as Error).message}])
                    }
                }
                else {
                    this.showErrors(payload.errors)
                }

            }
            catch(error) {
                this.showErrors([{message: (error as Error).message}])
            }
        }
        else {
            this.showErrors(validationResponse.errors);
        }

        this.signUpButton.value = `Create Account`;
    }

    protected async validateFields(fields: SignUpFields): Promise<ValidationResponse> {
        const errors: ValidationErrors = [];

        if (fields.name === '') {
            errors.push({message: 'Name must be entered'})
        }
        if (fields.email === '') {
            errors.push({message: 'Email must be entered'})
        }
        if (fields.password === '') {
            errors.push({message: 'Password must be entered'})
        }

        return {
            ok: errors.length === 0,
            errors
        }
    }

    protected showErrors(errors: ValidationErrors) {
        let errorMarkup = '';
        this.errorMessage.style.display = 'block';

        for (let i = 0; i < errors.length; i++) {
            const error = errors[i];
            errorMarkup += error.message + '<br />';
        }

        this.errorMessage!.innerHTML = errorMarkup;

    }

    protected redirectAfterSignup() {
        const next = this.getNextQueryParam();

        if (next !== undefined) {
            window.location.href = next;
            return;
        }

        window.location.href = '/views/account/my-account';
    }

    protected getNextQueryParam() {
        const params = new URLSearchParams(window.location.search);
        let next;

        for (const [key, value] of params) {
            if (key === 'next') {
                next = value;
            }
        }

        return next;
    }

    protected onPasswordShowHideButtonClick(event: Event) {
        const passwordType = this.passwordInput.type;

        if (passwordType === 'password') {
            this.passwordInput.type = 'text'
        }
        else {
            this.passwordInput.type = 'password'
        }
    }

    protected onSignUpSubmit(event: Event) {
        event.preventDefault();
        this.signUp();
    }
}

export function init(session: ConstructorParameters<typeof Signup>[0]): Signup | void {
    try {
        return new Signup(session);
    }
    catch (error) {
        console.error(error);
    }
}